// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"styles_checkbox__eZleL","hasError":"styles_hasError__A_VPG"};